export default {
  async addToShoppingCart({ commit, getters, rootState }, args) {
    const payload = {};

    if (!args) {
      payload.products = getters.productsToAddToShoppingCartPayload;
    } else if (args.productCode && args.quantity) {
      payload.products = [
        {
          product_code: args.productCode,
          product_url: args.productUrl,
          quantity: args.quantity
        }
      ];
    }

    console.log('addToShoppingCart', payload);

    const config = {
      params: {
        action: 'add_to_shopping_cart',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setShoppingCart', data);
  },
  async clearShoppingCart({ commit, rootState }) {
    const payload = {};

    console.log('clearShoppingCart', payload);

    const config = {
      params: {
        action: 'clear_shopping_cart',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setShoppingCart', data);
  },
  async getShoppingCart({ commit, rootState }) {
    const payload = {};

    const config = {
      params: {
        action: 'get_shopping_cart',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setShoppingCart', data);
  },
  async removeFromShoppingCart(
    { commit, rootState },
    { baseShape, productCode }
  ) {
    const payload = {};

    if (baseShape) {
      payload.base_shape = baseShape;
    }

    if (productCode) {
      payload.products = [
        {
          product_code: productCode
        }
      ];
    }

    console.log('removeFromShoppingCart', payload);

    const config = {
      params: {
        action: 'remove_from_shopping_cart',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setShoppingCart', data);
  },
  async setShoppingCartDeliveryDate({ commit, rootState }, args) {
    const payload = {};

    if (args?.date) {
      payload.requested_delivery_date = args.date.toISOString().split('T')[0];
    }

    console.log('setShoppingCartDeliveryDate', payload);

    const config = {
      params: {
        action: 'update_shopping_cart_delivery_date',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setShoppingCart', data);
  },
  async setShoppingCartQuantity(
    { commit, rootState },
    { productCode, quantity }
  ) {
    const payload = {
      products: [
        {
          product_code: productCode,
          quantity
        }
      ]
    };

    console.log('setShoppingCartQuantity', payload);

    const config = {
      params: {
        action: 'update_shopping_cart_product_quantity',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setShoppingCart', data);
  }
};
